<template>
    <!-- En-tête du panneau : client, commande, ajout de carte, fermeture -->
    <div class="ckp-head">
        <span class="ckp-avatar">{{ initials }}</span>
        <div class="ckp-head-text">
            <strong>
                Encaisser
                <a v-if="currentCustomer" :href="routeCustomerFile" target="_blank" rel="noopener">{{ fullName }}</a>
                <template v-else>la vente</template>
            </strong>
            <small>{{ orderId ? 'Commande n° ' + orderId : 'Nouvelle vente' }} · {{ itemsCount }} article{{ itemsCount > 1 ? 's' : '' }}</small>
        </div>
        <button
            v-if="currentCustomer && !isPassing"
            type="button"
            class="ck-button ck-button-small"
            @click="$emit('add-card')"
        >
            Ajouter une carte au compte
        </button>
        <a class="ckp-close" href="javascript:void(0)" data-toggle="layout" data-action="side_overlay_close" aria-label="Fermer">
            <i class="bi bi-x-lg"></i>
        </a>
    </div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
    props: ['currentCustomer', 'routeCustomerFile', 'orderId', 'itemsCount'],

    computed: {
        ...get('overlay@data', {
            c_customDiscount: 'customDiscount',
        }),
        fullName() {
            return [this.currentCustomer.first_name, this.currentCustomer.last_name].filter(Boolean).join(' ') || 'Client'
        },
        // Client de passage : pas de compte, donc pas de carte enregistrable
        isPassing() {
            return (this.currentCustomer?.first_name || '').toLowerCase() === 'client de passage'
        },
        initials() {
            if (!this.currentCustomer) return '—'
            return ((this.currentCustomer.first_name || '').charAt(0) + (this.currentCustomer.last_name || '').charAt(0)).toUpperCase() || '?'
        },
    },
}
</script>
